module.exports = __webpack_public_path__ + "static/media/aon_interno.c7f095d2.png";